import { render, staticRenderFns } from "./ptTableRowSoccer.vue?vue&type=template&id=bf82f704&lang=pug&"
import script from "./ptTableRowSoccer.vue?vue&type=script&lang=js&"
export * from "./ptTableRowSoccer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports